import React from "react";

import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

import styles from "./OnboardingTaskCard.module.css";

const OnboardingTaskSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.leftContent}>
        <Skeleton variant="rounded" width="60%" height={20} />
      </div>
      <Skeleton variant="rounded" width="80px" height={24} />
    </div>
  );
};

export default OnboardingTaskSkeleton;
